import {
  DAYS_IN_WEEK,
  GRID_DISPLAY_ADJUSTMENT,
  MILLISECONDS_PER_DAY
} from "./constants/constants";

export function getNumericDateAfter(initialDate, addDays) {
  let dateCopy = new Date();
  Object.assign(dateCopy, initialDate);

  dateCopy.setTime(dateCopy.getTime() + addDays * MILLISECONDS_PER_DAY);

  return new Intl.DateTimeFormat("default", {
    day: "numeric"
  }).format(dateCopy);
}

export function getAdjustedGridPosition(gridIndex, startsAt = 1) {
  // We default to starting at 1 because VueJS starts the iterator at 1
  // when iterating over a range of numbers (like indexes)
  const adjustedIndex = gridIndex - startsAt;

  const rowStart =
    Math.floor(adjustedIndex / DAYS_IN_WEEK) + GRID_DISPLAY_ADJUSTMENT;
  const colStart = (adjustedIndex % DAYS_IN_WEEK) + GRID_DISPLAY_ADJUSTMENT;

  return { gridRow: rowStart, gridCol: colStart };
}

export function convertTimeStringToDate(time, currentDateTime) {
  let date = currentDateTime;

  let [hours, minutes, seconds = "00"] = time.split(":");

  date.setHours(+parseInt(hours, 10));
  date.setMinutes(parseInt(minutes, 10));
  date.setSeconds(parseInt(seconds, 10));

  return date;
}

export function deepCopyDate(dateTime) {
  return new Date(JSON.parse(JSON.stringify(dateTime)));
}

/**
 * Slugifies a given string, using an underscore character as
 * a delimiter.
 *
 * @param string
 * @returns {string}
 */
export function underSlugify(text) {
  if (text) {
    return text
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9-]/gi, "_")
      .replace(/_+/g, "_")
      .replace(/^-|-$/g, "");
  }
}

export function generateArrayQueryParamsString(
  values,
  key,
  precedingQuery = ""
) {
  let queryString = precedingQuery;
  if (values) {
    if (Array.isArray(values)) {
      queryString = values.reduce((acc, value) => {
        if (!acc.length) {
          acc += "/?";
        } else {
          acc += "&";
        }
        acc += `${key}[]=${value}`;
        return acc;
      }, queryString);
    } else if (values.constructor === String) {
      queryString += queryString.length ? "&" : "/?";
      queryString += `${key}[]=${values}`;
    } else {
      throw "'values' parameter passed into generateArrayQueryParamsString() function needs to be either an Array or String.";
    }
  }
  return queryString;
}

export function logout(context) {
  if (window.localStorage.overrideAuth) {
    delete window.localStorage.overrideAuth;
    delete window.localStorage.contracts;
    delete window.localStorage.crewCounts;
    delete window.localStorage.crewLaborers;
    delete window.localStorage.crews;
    delete window.localStorage.customers;
    delete window.localStorage.projectCounts;
    delete window.localStorage.projects;
  } else if (window.localStorage.apiToken) {
    delete window.localStorage.apiToken;
    delete window.localStorage.userName;
    delete window.localStorage.userType;
    delete window.localStorage.userEmail;
  }
  if (context) {
    context.$router.push({ name: "login" });
  }
}

export function validateRequiredRefs(context, shouldScroll = false) {
  let invalidRefs = [];
  if (context.requiredRefs) {
    context.requiredRefs.forEach(ref => {
      let event = new Event("focusout");

      if (Array.isArray(context.$refs[ref])) {
        context.$refs[ref].forEach((component, i) => {
          component.$el.dispatchEvent(event);
          if (component.isInvalid) {
            invalidRefs.push(`${ref}_${i}`);
          }
        });
      } else {
        context.$refs[ref].$el.dispatchEvent(event);
        if (context.$refs[ref].isInvalid) {
          invalidRefs.push(ref);
        }
      }
    });
    if (shouldScroll) {
      if (invalidRefs.length) {
        context.$refs[invalidRefs[0]].$el.scrollIntoView();
        return false;
      }
    }
  }

  return invalidRefs.length === 0;
}

export function generateGoogleMapsUrl(place) {
  const streetAddress =
    place.address_1 && place.address_2
      ? `${place.address_1}, ${place.address_2}`
      : place.address_1;
  return `https://maps.google.com/?q=${streetAddress}, ${place.city}, ${place.state} ${place.zip}`;
}

export function sortContacts(a, b) {
  let primaryATerm;
  let secondaryATerm;
  if (a.company_name) {
    primaryATerm = a.company_name;
    secondaryATerm = a.last_name ? a.last_name : "";
  } else {
    primaryATerm = a.last_name;
    secondaryATerm = "";
  }

  let primaryBTerm;
  let secondaryBTerm;
  if (b.company_name) {
    primaryBTerm = b.company_name;
    secondaryBTerm = b.last_name ? b.last_name : "";
  } else {
    primaryBTerm = b.last_name;
    secondaryBTerm = "";
  }

  return (
    primaryATerm.localeCompare(primaryBTerm) ||
    secondaryATerm.localeCompare(secondaryBTerm)
  );
}
